import { catchError, tap } from 'rxjs/operators';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpParams,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

import { GetSessionUseCase, UpdateSessionUseCase } from '../../../core';
import { LocalStorage } from '../helpers/local-storage';
import { MainRoutes } from '../../main-routes.enum';
import { ParentEvents } from '../../utils/parent-events.service';

import { environment } from '../../../../environments/environment';

@Injectable()
export class ApiClientInterceptor implements HttpInterceptor {
    constructor(
        private getSessionUseCase: GetSessionUseCase,
        private localStorage: LocalStorage,
        private parentEvents: ParentEvents,
        private router: Router,
        private updateSessionUseCase: UpdateSessionUseCase
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const options: any = {};
        options.params = request.params as HttpParams;
        options.headers = request.headers as HttpHeaders;

        return new Observable((observer) => {
            if (request.url.includes('config.json')) {
                next.handle(request).subscribe(
                    (resp) => observer.next(resp),
                    (err) => observer.error(err),
                    () => observer.complete()
                );
            } else {
                this.getSessionUseCase.bind().subscribe(
                    (transaction) => {
                        if (transaction.isSuccess) {
                            if (transaction.data.token) {
                                options.headers = options.headers.append('Tower30-SessionToken', transaction.data.token);
                            }

                            if (transaction.data.code) {
                                if (environment.portalClient) {
                                    options.headers = options.headers.append('Tower30-ClientCode', transaction.data.code);
                                } else {
                                    options.headers = options.headers.append('Tower30-UserCode', transaction.data.code);
                                }
                            }

                            options.headers = options.headers.append('Tower30-Domain', transaction.data.domain);
                            options.headers = options.headers.append('Tower30-Language', transaction.data.language);
                        }

                        request = request.clone(options);

                        next.handle(request).subscribe(
                            (resp) => observer.next(resp),
                            (err) => observer.error(err),
                            () => observer.complete()
                        );
                    },
                    (_) => {
                        request = request.clone(options);

                        next.handle(request).subscribe(
                            (resp) => observer.next(resp),
                            (err) => observer.error(err),
                            () => observer.complete()
                        );
                    }
                );
            }
        }).pipe(
            tap((resp: HttpEvent<any>) => {
                if (resp instanceof HttpResponse) {
                    if (resp.headers.has('Tower30-SessionToken') && resp.headers.get('Tower30-SessionToken')) {
                        this.localStorage.sessionToken = resp.headers.get('Tower30-SessionToken');
                        this.updateSessionUseCase
                            .bind({
                                token: resp.headers.get('Tower30-SessionToken'),
                            })
                            .subscribe();
                    }
                }
            }),
            catchError((err) => {
                if (err instanceof HttpErrorResponse) {
                    const errorText = err.error.hasOwnProperty('Message')
                        ? err.error.Message
                        : err.error.hasOwnProperty('ExceptionMessage')
                        ? err.error.ExceptionMessage
                        : err.statusText;

                    if (err.status === 401 || err.status === 403) {
                        this.parentEvents.logout();
                        this.router.navigateByUrl(MainRoutes.UNAUTHORIZED);
                    }

                    return throwError(new Error(errorText));
                }

                return throwError(err);
            })
        );
    }
}
